import Video from '../../src/legacy/Video';
export default Video;
